import classNames from 'classnames';
import { ReactNode } from 'react';
import { CustomPopover } from '../custom-popover';
import styles from './index.module.scss';

export type TagType = 'gray' | 'yellow' | 'green' | 'pink' | 'blue' | 'white';

export type DotType = 'gray' | 'yellow' | 'green' | 'blue';

export const CommonTag = (props: {
  text?: string;
  type?: TagType;
  children?: ReactNode;
}) => {
  const { text, type = 'gray', children } = props;
  return (
    <span className={classNames(styles.commonTag, styles[type])}>
      {text || children}
    </span>
  );
};

export const CommonTagGroup = (props: {
  tip?: ReactNode;
  items: {
    text?: string;
    type?: TagType;
    children?: ReactNode;
  }[];
}) => {
  const { items, tip } = props;
  let elements;
  if (items.length > 2) {
    elements = (
      <span>
        {[items[0], items[1]].map((item) => (
          <CommonTag {...item} />
        ))}
        <CommonTag type={items[0].type} text={`+${items.length - 2}`} />
      </span>
    );
  } else {
    elements = (
      <span>
        {items.map((item) => (
          <CommonTag {...item} />
        ))}
      </span>
    );
  }

  return (
    <CustomPopover
      maxWidth={300}
      content={tip || items.map((item) => item.text).join('、')}
    >
      {elements}
    </CustomPopover>
  );
};

export const CommonDotStatus = (props: {
  type?: DotType;
  children?: ReactNode;
}) => {
  const { type = 'gray', children } = props;
  const colorMap = {
    gray: 'rgb(187, 187, 187)',
    yellow: '#f77e45',
    green: 'rgb(29, 171, 48)',
    blue: 'rgb(14, 127, 240)',
  };
  return (
    <span className={styles.dotStatus}>
      <span
        className={styles.dot}
        style={{ backgroundColor: colorMap[type] }}
      ></span>
      <> {children}</>
    </span>
  );
};
